export type CustomerMode = 'new' | 'existing'

interface NewExistingToggleProps {
  mode: CustomerMode
  onChange: (mode: CustomerMode) => void
}

export function NewExistingToggle({ mode, onChange }: NewExistingToggleProps) {
  return (
    <div className="flex rounded-[9px] overflow-hidden border border-[#e5e7eb] w-fit">
      {(['new', 'existing'] as const).map((m) => (
        <button
          key={m}
          onClick={() => onChange(m)}
          className="px-4 py-1.5 text-[11px] font-semibold transition-colors"
          style={mode === m ? { background: '#4f46e5', color: '#ffffff' } : { background: '#f8fafc', color: '#64748b' }}
        >
          {m === 'new' ? 'New Customer' : 'Existing Customer'}
        </button>
      ))}
    </div>
  )
}
